<template>

  <!-- begin::Header -->
  <header id="m_header" class="m-grid__item m-header " m-minimize="minimize" m-minimize-offset="200"
          m-minimize-mobile-offset="200">
    <div class="m-header__top">
      <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
        <div class="m-stack m-stack--ver m-stack--desktop">

          <!-- begin::Brand -->
          <div class="m-stack__item m-brand">
            <div class="m-stack m-stack--ver m-stack--general m-stack--inline">
              <div class="m-stack__item m-stack__item--middle m-brand__logo">
                <a href="index.html" class="m-brand__logo-wrapper">
                  <img alt="" src="static/demo/media/img/logo/sims_logo.png"/>
                </a>
              </div>
            </div>
          </div>

          <!-- end::Brand -->

          <!-- begin::Topbar -->
          <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
            <div id="m_header_topbar" class="m-topbar  m-stack m-stack--ver m-stack--general">
              <div class="m-stack__item m-topbar__nav-wrapper">
                <ul class="m-topbar__nav m-nav m-nav--inline">
                  <li
                    class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                    >
                    <a href="#" class="m-nav__link m-dropdown__toggle">
													<span class="m-topbar__userpic m--hide">
														<img src="static/app/media/img/users/user4.jpg"
                                 class="m--img-rounded m--marginless m--img-centered" alt=""/>
													</span>
                      <a @click="logout" class="m-topbar__username">Logout</a>
                    </a>
                    <div class="m-dropdown__wrapper">
                      <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
                      <div class="m-dropdown__inner">
                        <div class="m-dropdown__header m--align-center"
                             style="background: url(/static/app/media/img/misc/user_profile_bg.jpg); background-size: cover;">
                        </div>
                        <div class="m-dropdown__body">
                          <div class="m-dropdown__content">
                            <ul class="m-nav m-nav--skin-light">
                              <li class="m-nav__section m--hide">
                                <span class="m-nav__section-text">Section</span>
                              </li>
                              <li class="m-nav__item">
                                <a href="profile.html" class="m-nav__link">
                                  <i class="m-nav__link-icon flaticon-profile-1"></i>
                                  <span class="m-nav__link-title">
																				<span class="m-nav__link-wrap">
																					<span class="m-nav__link-text">My Profile</span>
																					<span class="m-nav__link-badge"><span
                                            class="m-badge m-badge--success">2</span></span>
																				</span>
																			</span>
                                </a>
                              </li>
                              <li class="m-nav__item">
                                <a href="profile.html" class="m-nav__link">
                                  <i class="m-nav__link-icon flaticon-share"></i>
                                  <span class="m-nav__link-text">Activity</span>
                                </a>
                              </li>
                              <li class="m-nav__item">
                                <a href="profile.html" class="m-nav__link">
                                  <i class="m-nav__link-icon flaticon-chat-1"></i>
                                  <span class="m-nav__link-text">Messages</span>
                                </a>
                              </li>
                              <li class="m-nav__separator m-nav__separator--fit">
                              </li>
                              <li class="m-nav__item">
                                <a href="profile.html" class="m-nav__link">
                                  <i class="m-nav__link-icon flaticon-info"></i>
                                  <span class="m-nav__link-text">FAQ</span>
                                </a>
                              </li>
                              <li class="m-nav__item">
                                <a href="profile.html" class="m-nav__link">
                                  <i class="m-nav__link-icon flaticon-lifebuoy"></i>
                                  <span class="m-nav__link-text">Support</span>
                                </a>
                              </li>
                              <li class="m-nav__separator m-nav__separator--fit">
                              </li>
                              <li class="m-nav__item">
                                <a href="snippets/pages/user/login-1.html"
                                   class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">Logout</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- end::Topbar -->
        </div>
      </div>
    </div>
    <div class="m-header__bottom">
      <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
        <div class="m-stack m-stack--ver m-stack--desktop">

          <!-- begin::Horizontal Menu -->

          <el-menu class="m-stack__item m-stack__item--middle m-stack__item--fluid" router
                   :default-active="$route.path"
                   mode="horizontal">
            <el-menu-item
              class="m-menu__item"
              :key="item.path" v-for="(item) in menus"
              :index="item.path">
              <span class="m-menu__item-here"></span>
              {{item.title}}
            </el-menu-item>
          </el-menu>
          <!-- end::Horizontal Menu -->
        </div>
      </div>
    </div>
  </header>

  <!-- end::Header -->

</template>
<script>
import menus from 'menu'
import { Menu, MenuItem, MenuItemGroup } from 'element-ui'

export default {
  components: {
    [Menu.name]: Menu,
    [MenuItem.name]: MenuItem,
    [MenuItemGroup.name]: MenuItemGroup,
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'LoginPage' })
    },
  },
  data () {
    return {
      menus: menus,
    }
  },
}
</script>
<style>
  .m-header .m-header__top {
    height: 40px;
  }

  .m-menu__item .m-menu__item-here {
    display: none !important;
    font-family: 'Nanum Gothic', sans-serif;
  }

  .m-stack.m-stack--desktop.m-stack--ver > .m-stack__item.m-stack__item--middle {
    border: none;
    font-family: 'Nanum Gothic', sans-serif;
  }

  .m-menu__item.is-active .m-menu__item-here {
    line-height: 0;
    display: inline-block;
    overflow: hidden;
    height: 16px;
    width: 60px;
    left: 50%;
    margin-left: -30px;
    position: absolute;
    top: 100%;
    z-index: 1;
    color: #262734;
    display: inline-block;
    font-family: 'Nanum Gothic', sans-serif;
  }

  .m-menu__item .m-menu__item-here:before {
    display: inline-block;
    font-family: "Metronic";
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    line-height: 0px;
    text-decoration: inherit;
    text-rendering: optimizeLegibility;
    text-transform: none;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    content: "";
    position: relative;
    top: 111%;
    margin-top: 13px;
    font-size: 60px;
  }

  .m-menu__item.is-active .m-menu__item-here {
    display: block !important;
  }

  .m-menu__item.is-active .m-menu__item-here:before {
    display: block !important;
    position: relative;
    top: 111%;
    margin-top: 13px;
    font-size: 60px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {

    outline: unset;
    color: unset;

  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-menu--horizontal > .el-menu-item.is-active,
  .el-menu, .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    color: #ffffff;
    background-color: unset;
    border: none;
  }

  .el-menu, .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
    background-color: unset !important;
  }

  .el-menu--horizontal > .el-menu-item.is-active {

    border-bottom: none !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// src/pages/Layout/TopNavbar.vue